import axiosApi from 'utils/axios';

export const getFeatureFlags = async () => {
  return axiosApi.get('/flipper/features').then(({ data }) => data as Record<string, boolean>);
};
